import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme.css';
import App from './App';
import WallboardStandalone from './WallboardStandalone';

// Die Raumanzeige laeuft unter einer eigenen Adresse mit eigener Anmeldung —
// deshalb hier abzweigen und NICHT in App.jsx. App.jsx prueft beim Start die
// Microsoft-Anmeldung und wuerde den Wandrechner auf die Login-Seite schicken,
// bevor die Wallboard-Anmeldung ueberhaupt zum Zug kaeme.
// Ein eigener Router waere fuer diese eine Abzweigung unverhaeltnismaessig.
const istWallboard = window.location.pathname.replace(/\/+$/, '') === '/wallboard';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {istWallboard ? <WallboardStandalone /> : <App />}
  </React.StrictMode>
);
